(function componentForm($, Adzuki)
{
	"use strict";

	var check = true;
	var form = {
		name: 'Package',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);

		$('#package-travel_start_date').on('dp.change', function cpvFromDateChange(e) {
			getCpvCount(check);
		});

		$('#package-travel_end_date').on('dp.change', function cpvFromDateChange(e) {
			getCpvCount(check);
		});

		$('.cpv_form').change(function cpvFormChange() {
			getCpvCount(check);
		});

		$('.cpv_cruise_line').change(function cruiseLineChanged() {
			var cruise_line_id = $(this).val();

			if ($.trim(cruise_line_id)) {
				getShips(cruise_line_id);
			}
		});
	});

	form.load = function load()
	{
		if (parseInt($('.cpv_cruise_line').val()) > 0) {
			getShips($('.cpv_cruise_line').val());
		} else {
			getCpvCount(true);
		}
	};

	function getCpvCount(check) {
		if (check === true) {
			Adzuki.Ajax.post('/Packages/getCount', $('#package-form').serialize()).then(
				function success(response) {
					$('.bottom-panel').addClass('show');
					$('.bottom-panel-result-count').html(response.count);
				}
			);
		}
	}

	function getShips(cruise_line_id) {
		Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id)
		.then(function success(data) {
			var sortedData = Adzuki.Sort.alphabeticValue(data);

			$('#package-ships').empty();
			$('#package-ships').append($('<option>').text('Any Ship').attr('value', ''));

			$.each(sortedData, function parseShips(key, ship) {
				$('#package-ships').append($('<option>').text(ship['value']).attr('value', ship['key']));
			});

			// if there is a ship that was set in the search criteria, select if after we ajax in the ships based on the cruise line
			if (parseInt($('#package-hidden_ship').val()) > 0) {
				$('#package-ships').val($('#package-hidden_ship').val());
			}

			getCpvCount(true);
		});
	}

}(jQuery, window.Adzuki || {}));